import React, { useState, useEffect } from 'react';
import { useAppSelector, shallowEqual } from 'store/hook';
import { MModal } from 'ui-component';
import { useTranslation } from 'react-i18next';
import { useStyles } from './index.style';
import { MForm, MInput, MButton } from 'ui-component/antdStyle';
import { Form, QRCode } from 'antd';
import GooglePlay from 'ui-component/icons/googleplay';
import AppleStore from 'ui-component/icons/appleStore';
import { getGoogleAuth, bindGoogleAuth, getUserDetail } from 'controller/auth';
import Notify from 'ui-component/Tools/Notify';

interface IHookProps {}

const CMP: React.FC<IHookProps> = ({}) => {
  const { t } = useTranslation(['common']);
  const { styles } = useStyles();
  const googleAuthStatus = useAppSelector(({ user }) => user.user?.userStatus?.googleAuthStatus, shallowEqual);
  const authConfig = useAppSelector(({ user }) => user.user?.overview?.authConfig, shallowEqual);
  const [form] = Form.useForm();
  const { setFieldsValue } = form;
  const [loading, setLoading] = useState<boolean>(false);
  const [qr, setQr] = useState<string | null>(null);
  useEffect(() => {
    const _getGoogleAuth = async () => {
      const res = await getGoogleAuth();
      if (res.success) {
        setQr(res.data?.qrImg || '');
      }
    };
    if (googleAuthStatus === 'UNPAIR' || googleAuthStatus === 'FAILED') {
      _getGoogleAuth();
    }
  }, [googleAuthStatus]);

  const onSubmit = () => {
    form
      .validateFields()
      .then(async (values: any) => {
        setLoading(true);
        const res = await bindGoogleAuth({
          pin: values.pin
        });
        setLoading(false);
        if (res.success) {
          if (res.data) {
            Notify('success', t('tips.bindSuccess', { ns: 'common' }));
            getUserDetail();
          } else {
            Notify('error', t('pinNotSame', { ns: 'common' }));
          }
        }
      })
      .catch(() => {});
  };

  return (
    <MModal
    open={((!authConfig?.skipMfa || !authConfig?.skipPinCheck) && googleAuthStatus === 'UNPAIR') || googleAuthStatus === 'FAILED'}
      title={t('openTwoVerify', { ns: 'common' })}
      hiddenCancel
      width={600}
      loading={loading}
      hiddenFooter
      noCloseIcon
    >
      <div className={styles.container}>
        <div>{t('openTwoVerifyDesc', { ns: 'common' })}</div>
        <div className={styles.title}>1. {t('downloadGoogle', { ns: 'common' })}</div>
        <div className={styles.downloadWrap}>
          <div className={styles.apple} onClick={() => window.open('https://apps.apple.com/us/app/google-authenticator/id388497605')}>
            <AppleStore width={141} height={33} />
          </div>
          <div
            className={styles.cursor}
            onClick={() => window.open('https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2')}
          >
            <GooglePlay width={158} height={47} />
          </div>
        </div>
        <div className={styles.title}>2. {t('scanCode', { ns: 'common' })}</div>
        {qr && <QRCode value={qr} />}
        <div className={styles.title}>3. {t('enterCodeBind', { ns: 'common' })}</div>
        <MForm layout="vertical" form={form}>
          <Form.Item label="PIN" name="pin" rules={[{ required: true, message: t('enterGoogleAuth', { ns: 'common' }) }]}>
            <MInput placeholder={t('enterGoogleAuth', { ns: 'common' })} />
          </Form.Item>
          <div>
            <MButton type="primary" small onClick={() => onSubmit()}>
              {t('submitVerify', { ns: 'common' })}
            </MButton>
          </div>
        </MForm>
      </div>
    </MModal>
  );
};

export default CMP;
